import React, { ReactNode, useState } from 'react';
import { window } from 'browser-monads';
import RichText from '../rich-text';
import { ModalWithButtons } from '@nvs/leap-web-components';
import {
	EventKeys,
	EventCategory,
	EventAction,
	EventLabel,
	EventValues,
} from '../../../../services/analytics';
import useTranslation from '../../../../hooks/useTranslation';
import useAnalytics from '../../../../hooks/useAnalytics';
import { getPosition } from '../../../../services/analytics-helper';

interface IInterSitial {
	link: string;
	className?: string;
	target?: string;
	rel?: string;
	eventLabel: string;
	children: ReactNode;
	position?: string;
}

export const InterSitial: React.FC<IInterSitial> = ({
	link,
	className,
	target,
	rel,
	children,
	eventLabel,
	position,
}) => {
	const { t } = useTranslation();
	const analytics = useAnalytics();
	const [isOpen, setIsOpen] = useState(false);
	const iconPosition = getPosition(position);

	const sendGAEvents = (buttonLabel: string) => {
		analytics.sendEvent({
			[EventKeys.EventCategory]: EventCategory.Navigation,
			[EventKeys.EventAction]: `${EventAction.ExternalLink} - ${iconPosition}`,
			[EventKeys.EventLabel]: buttonLabel,
			[EventKeys.ExternalLink]: link,
			[EventKeys.ExternalLinkText]: eventLabel ? eventLabel : EventLabel.Ok,
			[EventKeys.PageRequestTime]: new Date().getTime(),
			[EventKeys.PageURL]: `${window.location.href}`,
			[EventKeys.Event]: EventValues.GAEvent,
		});
		return null;
	};

	const modalTitle = <RichText html={t('pages.utilities.intersitial.title')} />;
	const cancelTranslation = 'pages.utilities.intersitial.cancel';

	return (
		<>
			<a
				className={className}
				href={link}
				onClick={(event) => {
					setIsOpen(true);
					sendGAEvents(eventLabel);
					event.preventDefault();
				}}
				rel={rel}
				target={target}
				aria-label={eventLabel}>
				{children}
			</a>
			<ModalWithButtons
				onClose={() => {
					setIsOpen(false);
					sendGAEvents(t(cancelTranslation));
				}}
				open={isOpen}
				primaryButton={{
					text: t('pages.utilities.intersitial.accept'),
					function: () => {
						sendGAEvents(t('pages.utilities.intersitial.accept'));
						window.open(link, target);
						setIsOpen(false);
					},
				}}
				secondaryButton={{
					text: t(cancelTranslation),
					function: () => {
						sendGAEvents(t(cancelTranslation));
						setIsOpen(false);
					},
				}}
				title={modalTitle}>
				<RichText html={t('pages.utilities.intersitial.message')} />
			</ModalWithButtons>
		</>
	);
};

export default InterSitial;
